module.exports = __webpack_public_path__ + "img/evaluation_tips.db29cc57.png";